/**
 * W8b (besluit Frank 22 oktober 2026, keuze a): de mailconcepten van een agentrun,
 * voor het spoorpaneel. Een agent stelt alleen op, op een mail-id uit de opdracht;
 * versturen doet de persoon zelf met de bestaande mailkaart.
 *
 * PUUR.
 */

/** Dezelfde naam als in `agent_tools.AGENT_TOOLS` in de backend. */
export const MAIL_CONCEPT_TOOL = "draft_mail_reply";

/** De concepten van een spoorregel, alleen de geslaagde, met wat de kaart nodig heeft. */
export function mailconcepten(steps) {
  return (steps || [])
    .filter((s) => s && s.type === "claw_tool" && s.tool === MAIL_CONCEPT_TOOL
      && s.outcome === "ok" && s.mail_concept && s.mail_concept.id)
    .map((s) => ({ ...s.mail_concept }));
}
